import React from 'react'
import { connect } from 'react-redux'
import {toggle} from '../fm/reducers/page'
import {Img, Text} from '../fm/field'
import Scrollbar from '../fm/lib/Scrollbar'

const PersonDetails = ({person, toggle}) => {
	if(!person) return null
	
	return (
		<div className='person-details'><div className='content'>
			<div className='close' onClick={toggle}><i className='fa fa-close'></i></div>
			<div className='content-in'>
			{person.img && <Img src={person.img} proportional={false}/>}
			<div className='text'>
				<Scrollbar>
				<h1>
					<Text entity={person} fieldName='first_name' plain={true} value={person.first_name} tag='span' type='entity' path='first_name'/>
					<br/>
					<Text entity={person} fieldName='last_name' plain={true} value={person.last_name} tag='span' type='entity' path='last_name'/>
				</h1>
				{person.position && <Text entity={person} plain={true} fieldName='position' value={person.position} type='entity' path='position'/>}
				<Text entity={person} fieldName='body' value={person.body} type='entity' path='body'/>
				</Scrollbar>
			</div>
			</div>
		</div></div>
	)
}

export default connect(state => {
	if (!state.page.props.personDetails || !state.page.props.personDetails.state) return {}
	const {view, index} = state.page.props.personDetails.data
	if(!state.page[view.id]) return {}
	return {person: state.page[view.id].data[index]}
}, (dispatch, {entity}) => ({
	toggle: e => dispatch(toggle('personDetails'))
}))(PersonDetails)



// WEBPACK FOOTER //
// ./src/components/PersonDetails.js